import * as React from 'react';
import "../styles/pages/not-found.scss";

export const NotFound = () => (
    <div style={{ textAlign: "center" }}>
        <h1>OOPS! PAGE NOT FOUND</h1>
        <div>
            <div
                style={{
                    margin: "50px auto",
                    width: "50%",
                    display: "grid",
                    gridTemplateColumns: " 1fr",
                    gap: "5px",
                }}
            >
                WE ARE SORRY, BUT THE PAGE YOU REQUESTED WAS NOT FOUND. OR YOU DON'T HAVE PERMISSIONS
            </div>
        </div>
    </div>
);

